import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@mui/styles/withStyles";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

const styles = theme => {
  const imageCropperBorder = `solid 4px ${theme.palette.admin}`;
  return {
    "@global": {
      ".ReactCrop": {
        border: `solid 1px ${theme.palette.secondary[300]}`
      },
      ".ReactCrop__crop-selection": {
        border: "none",
        "& .ReactCrop__drag-handle": {
          border: "none",
          height: 12,
          width: 12,
          background: "none",
          "&.ord-nw": {
            borderTop: imageCropperBorder,
            borderLeft: imageCropperBorder,
            marginLeft: -2,
            marginTop: -2
          },
          "&.ord-n": {
            borderTop: imageCropperBorder,
            marginTop: -2
          },
          "&.ord-ne": {
            borderTop: imageCropperBorder,
            borderRight: imageCropperBorder,
            marginRight: -2,
            marginTop: -2
          },
          "&.ord-w": {
            borderLeft: imageCropperBorder,
            marginLeft: -2
          },
          "&.ord-sw": {
            borderBottom: imageCropperBorder,
            borderLeft: imageCropperBorder,
            marginLeft: -2,
            marginBottom: -2
          },
          "&.ord-s": {
            borderBottom: imageCropperBorder,
            marginBottom: -2
          },
          "&.ord-se": {
            borderBottom: imageCropperBorder,
            borderRight: imageCropperBorder,
            marginRight: -2,
            marginBottom: -2
          },
          "&.ord-e": {
            borderRight: imageCropperBorder,
            marginRight: -2
          }
        }
      }
    }
  };
};

class ProfilePictureWithCropper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crop: {
        aspect: 1,
        x: 90,
        y: 15,
        width: 192,
        height: 192
      },
      blob: null,
      croppedImageUrl: null,
      refPic: this.props.profilePicture
    };
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      // check for IE
      if (window.document.documentMode || /Edge/.test(navigator.userAgent)) {
        let blob = canvas.msToBlob();
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        resolve(blob);
      } else {
        canvas.toBlob(function(blob) {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          resolve(blob);
        }, "image/png");
      }
    });
  }

  makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      this.getCroppedImg(this.imageRef, crop, "newProfileImage.png").then(
        blob => {
          this.props.onProfilePictureBlobChange(blob);
        }
      );
    }
  }

  onCropChange = crop => {
    this.setState({ crop });
  };

  onImageLoaded = image => {
    this.imageRef = image;
  };

  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  render() {
    const { profilePicture } = this.props;

    return (
      <div>
        <ReactCrop
          src={profilePicture}
          crop={this.state.crop}
          onComplete={this.onCropComplete}
          onImageLoaded={this.onImageLoaded}
          onChange={this.onCropChange}
        />
      </div>
    );
  }
}

export default withStyles(styles)(ProfilePictureWithCropper);

ProfilePictureWithCropper.propTypes = {
  profilePicture: PropTypes.any,
  onProfilePictureBlobChange: PropTypes.func,
  profilePictureContentType: PropTypes.any
};
